import React from 'react';
import classnames from 'classnames';

import s from './PlaceholderBlock.scss';

export interface Props {
  width?: number;
  height?: number;
  className?: string;
}

const PlaceholderBlock: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  width,
  height,
  children,
}) => {
  return (
    <div style={{ width, height }} className={classnames(s['root'], className)}>
      {children}
    </div>
  );
};
PlaceholderBlock.displayName = 'PlaceholderBlock';

export default PlaceholderBlock;
